
import React from 'react';
import { Language } from '../../types';
import AuthVisuals from './AuthVisuals';
import AuthFormContainer from './AuthFormContainer';

interface AuthComponentProps {
  isLoading: boolean;
  googleBtnRef: React.RefObject<HTMLDivElement>;
  featuresSlides: any[];
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
  renderMockup: (type: string) => React.ReactNode;
  isMobileFormVisible: boolean;
  setIsMobileFormVisible: (visible: boolean) => void;
  language: Language;
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
  onSwitchLanguage: (lang: Language) => void;
  onLahjaLogin: () => void;
}

const AuthComponent: React.FC<AuthComponentProps> = (props) => {
  const isRtl = props.language === 'ar';

  return (
    <div className={`fixed inset-0 z-[200] flex bg-white dark:bg-[#08080a] ${isRtl ? 'flex-row' : 'flex-row-reverse'}`}>
      <AuthVisuals 
        isMobileFormVisible={props.isMobileFormVisible}
        setIsMobileFormVisible={props.setIsMobileFormVisible}
        language={props.language}
        theme={props.theme}
        onToggleTheme={props.onToggleTheme}
        onSwitchLanguage={props.onSwitchLanguage}
        featuresSlides={props.featuresSlides}
        currentSlide={props.currentSlide}
        setCurrentSlide={props.setCurrentSlide}
        renderMockup={props.renderMockup}
      />
      <AuthFormContainer 
        isLoading={props.isLoading}
        googleBtnRef={props.googleBtnRef}
        isMobileFormVisible={props.isMobileFormVisible}
        setIsMobileFormVisible={props.setIsMobileFormVisible}
        language={props.language}
        onLahjaLogin={props.onLahjaLogin}
      />
    </div>
  );
};

export default AuthComponent;
